"use strict";
import { Map, Record } from "immutable";
const undecoratedModel = (modelName, hash) => {
  if (hash) {
    return {
      name: modelName,
      actions: [],
      create(overrideHash) {
        hash["__type__"] = modelName + "Model";
        return Record(hash)(overrideHash);
      }
    };
  } else {
    return {
      name: modelName,
      actions: [],
      create(hash2) {
        return Map(hash2).set("__type__", modelName + "Model");
      }
    };
  }
};
const defineModel = (modelName, hash) => {
  const model = undecoratedModel(modelName, hash);
  model.Action = (actionName) => {
    const fullActionName = modelName + "." + actionName;
    model.actions[actionName] = fullActionName;
    return fullActionName;
  };
  return model;
};
export default defineModel;
